//  export const ApiConnectionString = "https://localhost:7157"



  export const ApiConnectionString = "https://memboticapi-bdbybkguf5hsckbb.ukwest-01.azurewebsites.net"




